var _circle, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInProgressQuoteStatusIcon = function SvgInProgressQuoteStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#7200CC",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 16,
    x: 32.727,
    y: 19,
    fill: "#7200CC",
    rx: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 11.556,
    x: 27.818,
    y: 23.445,
    fill: "#7200CC",
    rx: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 8,
    x: 22.909,
    y: 27,
    fill: "#7200CC",
    rx: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.273,
    height: 4.444,
    x: 18,
    y: 30.555,
    fill: "#7200CC",
    rx: 0.4
  })));
};
export { SvgInProgressQuoteStatusIcon as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/QuoteStatus/assets/in-progress-quote-status-icon.072cd343c25d8aeb9dcac5958e781b06.svg";